import { AxiosResponse } from "axios";
import { AnyAction } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";
import { GetConversationSummary, GetWhatsappConversations, PostWhatsappUser } from "../../../actionTypes/whatsapp";
import { WhatsappConversation } from "../../../interfaces/resources/whatsapp";
import { apiFailureAction } from "../actions";
import * as apiClient from "./api";

export function* postWhatsappUser(action: AnyAction) {
  try {
    const response: AxiosResponse = yield call(apiClient.postWhatsappUser);
    yield put({ type: PostWhatsappUser.SUCCESS, payload: response.data });
  } catch (e) {
    yield put(apiFailureAction(e, action));
  }
}

export function* getWhatsappConversations(action: AnyAction) {
  try {
    const response: AxiosResponse<{
      "hydra:member": WhatsappConversation[];
      "hydra:view"?: {
        "hydra:next"?: string;
      };
    }> = yield call(apiClient.getWhatsappConversations, action.talent);
    const conversations = response.data["hydra:member"];
    yield put({ type: GetWhatsappConversations.SUCCESS, payload: conversations });
  } catch (e) {
    yield put(apiFailureAction(e, action));
  }
}

export function* getConversationSummary(action: AnyAction) {
  try {
    const response: AxiosResponse = yield call(apiClient.getConversationSummary, action.talent);
    const conversations = response.data["hydra:member"];
    yield put({ type: GetWhatsappConversations.SUCCESS, payload: conversations });
  } catch (e) {
    yield put(apiFailureAction(e, action));
  }
}

export default function* whatsappSaga() {
  yield takeLatest(PostWhatsappUser.REQUEST, postWhatsappUser);
  yield takeLatest(GetWhatsappConversations.REQUEST, getWhatsappConversations);
  yield takeLatest(GetConversationSummary.REQUEST, getConversationSummary);
}
